module.exports = __webpack_public_path__ + "img/ski_place1.55af1831.png";